import { Badge } from "@/components/ui/badge"
import type { BidStatus } from "@/types/bids"

/** The bids-list status vocabulary: Draft (community still bidding),
 *  Active (sent or won), Lost — plus the derived ⚠ rebid flag, which is
 *  staleness, not a status. */
export function BidStatusBadge({
  status,
  rebidNeeded = false,
}: {
  status: BidStatus
  rebidNeeded?: boolean
}) {
  if (rebidNeeded) {
    return (
      <Badge tone="signal" data-testid="bid-status">
        ⚠ Rebid — inputs changed
      </Badge>
    )
  }
  const tone = status === "active" ? "accent" : status === "lost" ? "muted" : "neutral"
  const label = status === "active" ? "Active" : status === "lost" ? "Lost" : "Draft"
  return (
    <Badge tone={tone} data-testid="bid-status">
      {label}
    </Badge>
  )
}

export const PRICING_FORMAT_LABELS = {
  room_level_totals: "Room & level totals",
  sf_price_only: "SF price only",
} as const

export const WASTE_HANDLING_LABELS = {
  net: "net SF",
  waste_in: "waste in",
} as const
